<div class="page_title">
    <div class="container-fluid">
        <div class="row">
            <div class="col-auto" *ngIf="this.claimId">
                <k-button [type]="KButtonType.KLAiMSButton" [label]="'Back'" [color]="'brand-main'"
                    [icon]="{type: 'kennedys', name: 'back-arrow'}" (buttonClick)="goToPage()">
                </k-button>
            </div>
            <div class="col">
                <h3>Exposure</h3>
                <app-custom-breadcrumb *ngIf="customData" [data]="customData"></app-custom-breadcrumb>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid">
    <div class="pages_space">
        <section id="stage1" class="outline_exp" *ngIf="showStage1">
            <!-- <div class="row">
                <div class="col-auto" *ngIf="this.claimId">
                    <k-button [type]="KButtonType.KLAiMSButton" [label]="'Back'" [color]="'brand-main'"
                        [icon]="{type: 'kennedys', name: 'back-arrow'}" (buttonClick)="goToPage()" >
                    </k-button> 
                </div>
                <div class="col">
                    <h3>Exposure</h3>
                </div>
            </div> -->
            <div class="row">
                <div class="col-12">
                    <div class="form-row align-items-center d-flex justify-content-center">
                        <div class="col-auto">
                            <label class="me-3">Add an activity the claimant performed to begin </label>
                            <k-button [type]="KButtonType.KLAiMSButton" [label]="'Add Activity'" [color]="'brand-main'"
                                (buttonClick)="addNewActivity()">
                            </k-button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div id="stage4">
            <section>
                <p>Dose Summary</p>
            </section>
            <section>
                <k-table-grid (clickOnActionEvent)="getTableData($event)">
                </k-table-grid>
            </section>
            <br>
            <!-- <section>
                <div class="col-12 text-center" *ngIf="this.sampleData.length > 0">
                    <k-button [type]="KButtonType.KLAiMSButton" [label]="'Complete Exposure'" [color]="'brand-main'"
                        (buttonClick)="completeExposure()">
                    </k-button>
                </div>
            </section> -->
        </div>
    </div>
</div>

<k-modal [overlay]="true" [id]="'deleteActivityModal'">
    <k-modal-header [dismiss]="true" [backgroundColor]="'brand-main'">
        <strong>Confirm</strong>
    </k-modal-header>
    <k-modal-body>
        <div class="row">
            <div class="col-sm-12">
                <div class="text">
                    Delete activity? This cannot be undone.
                </div>
            </div>
        </div>
    </k-modal-body>
    <k-modal-footer>
        <k-button [type]="KButtonType.KLAiMSButton" [label]="'Delete'" [color]="'brand-main'"
            (buttonClick)="deleteActivity(this.currentActivityId)"></k-button>
        <k-button [type]="KButtonType.KLAiMSButton" [label]="'Cancel'" [subType]="KKcgButtonSubType.Cancel"
            [color]="'dark-grey'" (buttonClick)="closeDeleteActivityModal()"></k-button>
    </k-modal-footer>
</k-modal>
<k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
    [timeout]="timeout"></k-simple-alert>